import { ApiError, ApiErrorEntity } from '../types/general';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';

export function useTranslatedErrorCodes() {
  const { t } = useTranslation();

  function translateErrorCode(es: ApiErrorEntity, errorSection: string) {
    if (!es.code) return t('register.error.somethingWentWrong');

    return t(`${errorSection}.${es.code}`, es.code);
  }

  function translateError(error: Error, errorSection: string) {
    let errors = [error.message];
    if (error instanceof AxiosError) {
      const apiError = error.response?.data as ApiError;
      if (apiError) {
        errors = [...new Set(apiError.errors.map((es) => translateErrorCode(es, errorSection)))];
      }
    }
    return errors;
  }

  return {
    translateErrorCode,
    translateError,
  };
}
